export const PLAID_LINK_TOKEN_KEY = "link_token"
export const PLAID_RETURN_URL_KEY = "plaid_return_url"
export const PLAID_SUCCESS_METADATA_KEY = "plaid_success_metadata"
